import React from "react";

const Divider = () => {
    return(
        <div className="h-3 bg-gray-extraLight border-t border-b border-gray-extraLight"/>
    )
}
export default Divider;